
import Vue from "vue";
import Component from "vue-class-component";
import { registerSw } from "@/registerServiceWorker";
import NavigationDrawer from "@/components/app/NavigationDrawer.vue";
import GlobalSnackbar from "@/components/app/GlobalSnackbar.vue";

@Component({
  components: {
    UpdateAlert: () => import("@/components/app/UpdateAlert.vue"),
    NavigationDrawer,
    GlobalSnackbar,
    Footer: () => import("@/components/app/Footer.vue"),
  },
})
export default class App extends Vue {
  private newUpdate = false;
  private baseURL = window.location.origin;

  // 🚩 Flag for whether the footer should be shown based on the current route
  private get showFooter(): boolean {
    return (
      this.$route.path.includes("/stats") &&
      !this.$store.state.authorization.isAuthorized
    );
  }

  private created() {
    document.title = "One Click Crypto";

    if (
      this.baseURL.includes("app.onebutton.trade") ||
      this.baseURL.includes("app.onebutton.capital")
    ) {
      window.location.replace(
        "https://app.oneclick.fi" + window.location.pathname + window.location.search
      );
    }

    // In development mode use a different port
    if (this.baseURL.includes("localhost")) {
      this.baseURL = "https://app.oneclick.fi";
    }

    Vue.axios.defaults.withCredentials = false;
    Vue.axios.defaults.timeout = 60000;
    Vue.axios.defaults.baseURL = this.baseURL;

    this.$vuetify.theme.dark = this.$store.state.userPreferences.darkMode;
  }

  private async mounted() {
    registerSw({
      updatefound: (reg) => {
        const installingWorker = reg.installing!;
        installingWorker.onstatechange = () => {
          switch (installingWorker.state) {
            case "installed":
              if (navigator.serviceWorker.controller) {
                // new update available
                this.newUpdate = true;
                // TODO: check if window.location.reload(true) is a better UX
              } else {
                // no update available
                this.newUpdate = false;
              }
              break;
          }
        };
      },
    });

    // Initial notifications fetch in order to display them in the navigation drawer
    if (
      this.$store.state.authorization.isAuthorized &&
      this.$store.state.authorization.authorizationToken !== undefined
    ) {
      this.$store.dispatch("fetchNotifications");
    }

    // Fetch notifications every 180 seconds
    setInterval(() => {
      if (
        this.$store.state.authorization.isAuthorized &&
        this.$store.state.authorization.authorizationToken !== undefined
      ) {
        this.$store.dispatch("fetchNotifications");
      }
    }, 180000);
  }
}
